<div class="easypass-redeem-container">
    <!-- Loading Easypass info -->
    @if (isLoadingInfo()) {
    <jjames-loading></jjames-loading>
    }

    <!-- Not found -->
    @else if (isNotFound()) {
    <jjames-card>
        <div class="error-content">
            <mat-icon class="error-icon">link_off</mat-icon>
            <h2>{{ 'EASYPASS_REDEEM.INVALID_LINK_TITLE' | translate }}</h2>
            <p>{{ 'EASYPASS_REDEEM.INVALID_LINK_TEXT' | translate }}</p>
        </div>
    </jjames-card>
    }

    <!-- Exit ticket already used or expired -->
    @else if (isError() && easypassInfo()?.isExitTicket && (easypassInfo()?.isConsumed || easypassInfo()?.isExpired)) {
    <jjames-card>
        <div class="error-content">
            <mat-icon class="error-icon">confirmation_number</mat-icon>
            <h2>{{ (easypassInfo()?.isExpired ? 'EASYPASS_REDEEM.TICKET_EXPIRED_TITLE' : 'EASYPASS_REDEEM.TICKET_USED_TITLE') | translate }}</h2>
            <p>{{ errorMessage()?.key ?? '' | translate: errorMessage()?.params }}</p>
        </div>
    </jjames-card>
    }

    <!-- Invitation full -->
    @else if (isError() && easypassInfo()?.isConsumed) {
    <jjames-card>
        <div class="error-content">
            <mat-icon class="error-icon">event_busy</mat-icon>
            <h2>{{ 'EASYPASS_REDEEM.FULLY_BOOKED_TITLE' | translate }}</h2>
            <p>{{ 'EASYPASS_REDEEM.FULLY_BOOKED_TEXT' | translate }}</p>
        </div>
    </jjames-card>
    }

    <!-- Redemption success -->
    @else if (isSuccess()) {
    <jjames-card>
        <div class="success-content">
            <mat-icon class="success-icon">check_circle</mat-icon>
            <h2>{{ 'EASYPASS_REDEEM.SUCCESS_TITLE' | translate }}</h2>
            @if (successMessage(); as message) {
            <p class="success-main">{{ message.key | translate: message.params }}</p>
            }
            @if (successValidTo()) {
            <p>{{ 'EASYPASS_REDEEM.VALID_UNTIL' | translate }} <strong>{{ successValidTo() | date: 'dd.MM.yyyy, HH:mm' }}</strong></p>
            }
            <jjames-button variant="primary" (clicked)="HomeClicked()">
                {{ 'EASYPASS_REDEEM.GO_HOME' | translate }}
            </jjames-button>
        </div>
    </jjames-card>
    }

    <!-- Redemption error (non-consumed) -->
    @else if (isError()) {
    <jjames-card>
        <div class="error-content">
            <mat-icon class="error-icon">error_outline</mat-icon>
            <h2>{{ 'EASYPASS_REDEEM.FAILED_TITLE' | translate }}</h2>
            <p>{{ errorMessage()?.key ?? '' | translate: errorMessage()?.params }}</p>
            <jjames-button variant="secondary" (clicked)="isError.set(false)">
                {{ 'EASYPASS_REDEEM.TRY_AGAIN' | translate }}
            </jjames-button>
        </div>
    </jjames-card>
    }

    <!-- Easypass info + redemption form -->
    @else if (easypassInfo()) {
    <jjames-card>
        <div class="form-content">
            <h2>{{ 'EASYPASS_REDEEM.TITLE' | translate }}</h2>

            <!-- Easypass details -->
            <div class="easypass-details">
                @if (easypassInfo()?.title) {
                <div class="detail-row">
                    <mat-icon>event</mat-icon>
                    <span><strong>{{ easypassInfo()?.title }}</strong></span>
                </div>
                }
                <!-- An exit ticket is one ticket for one exit: no capacity or re-entries to show. -->
                @if (!easypassInfo()?.isExitTicket) {
                <div class="detail-row">
                    <mat-icon>confirmation_number</mat-icon>
                    @let capacity = remainingCapacityDisplay();
                    <span><strong>{{ 'EASYPASS_REDEEM.RESERVATIONS' | translate }}</strong> {{ capacity.key | translate: capacity.params }}</span>
                </div>
                }
                <div class="detail-row">
                    <mat-icon>calendar_today</mat-icon>
                    <span><strong>{{ (easypassInfo()?.isExitTicket ? 'EASYPASS_REDEEM.VALID_UNTIL' : 'EASYPASS_REDEEM.EXPIRES') | translate }}</strong>
                        @if (easypassInfo()?.validTo) { {{ easypassInfo()?.validTo | date: 'shortDate' }} }
                        @else { {{ 'EASYPASS_REDEEM.NO_EXPIRY' | translate }} }
                    </span>
                </div>
                @if (!easypassInfo()?.isExitTicket) {
                <div class="detail-row">
                    <mat-icon>repeat</mat-icon>
                    @let entries = allowedEntriesDisplay();
                    <span><strong>{{ 'EASYPASS_REDEEM.RE_ENTRIES' | translate }}</strong> {{ entries.key | translate: entries.params }}</span>
                </div>
                }
                @if (easypassInfo()?.description) {
                <div class="detail-row">
                    <mat-icon>notes</mat-icon>
                    <span>{{ easypassInfo()?.description }}</span>
                </div>
                }
            </div>

            <p class="mt-3">{{ 'EASYPASS_REDEEM.INSTRUCTION' | translate }}</p>

            <form [formGroup]="redeemForm" (ngSubmit)="onSubmit()">
                <div class="plate-field">
                    <label class="plate-label" for="licensePlate">{{ 'EASYPASS_REDEEM.PLATE_LABEL' | translate }}</label>

                    <app-plate editable [euBand]="country.euBand" [countryCode]="country.code">
                        <input id="licensePlate" type="text" class="plate-input" formControlName="licensePlate"
                               (input)="onPlateFieldInput($event)" [maxlength]="maxPlateLength"
                               autocomplete="off" spellcheck="false" placeholder="LL123AB" />
                    </app-plate>

                    @if (redeemForm.get('licensePlate')?.touched && redeemForm.get('licensePlate')?.invalid) {
                    <span class="plate-error">{{ 'EASYPASS_REDEEM.PLATE_INVALID' | translate }}</span>
                    }
                </div>

                <jjames-button variant="primary" type="submit" [disabled]="redeemForm.invalid || isLoading()"
                    [loading]="isLoading()">
                    {{ 'EASYPASS_REDEEM.SUBMIT' | translate }}
                </jjames-button>
            </form>
        </div>
    </jjames-card>
    }
</div>